import {useTranslation} from "react-i18next";
import {ReactComponent as SafeIcon} from "assets/img/icon/secure.svg"

export function Paysafe({payment, children}) {
  const {t, i18n} = useTranslation()

  return (
    <p className={'row success-text'} style={{justifyContent: 'center', gap: '0.5rem'}}>
      <SafeIcon fill={'currentColor'}/>
      <em className={'small'}>{
        children || (
          payment && i18n.exists('payment.secure')
            ? t('payment.secure')
            : t('paywall.plan.secure')
        )
      }</em>
    </p>
  )
}
